import { render, staticRenderFns } from "./ProductOptionSelectorPpd.vue?vue&type=template&id=7b2608db&scoped=true&"
import script from "./ProductOptionSelectorPpd.vue?vue&type=script&lang=js&"
export * from "./ProductOptionSelectorPpd.vue?vue&type=script&lang=js&"
import style0 from "./ProductOptionSelectorPpd.vue?vue&type=style&index=0&id=7b2608db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2608db",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b2608db')) {
      api.createRecord('7b2608db', component.options)
    } else {
      api.reload('7b2608db', component.options)
    }
    module.hot.accept("./ProductOptionSelectorPpd.vue?vue&type=template&id=7b2608db&scoped=true&", function () {
      api.rerender('7b2608db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/commonUBossCustomize/Ppd/ProductOptionSelectorPpd.vue"
export default component.exports